import { render } from "./VacancieCard.vue?vue&type=template&id=7b009356&scoped=true"
import script from "./VacancieCard.vue?vue&type=script&lang=js"
export * from "./VacancieCard.vue?vue&type=script&lang=js"

import "./VacancieCard.vue?vue&type=style&index=0&id=7b009356&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b009356"]])

export default __exports__